import React from "react";

const usd = (v) => (v == null ? "--" : `$${Number(v).toLocaleString(undefined, { maximumFractionDigits: 0 })}`);
const NAMES = [["alpaca", "ALPACA"], ["coinbase", "COINBASE"], ["kalshi", "KALSHI"], ["tradier", "TRADIER"], ["tastytrade", "TASTY"]];

export const TvBrokers = ({ brokers, hidden }) => {
  if (!brokers) return null;
  const show = (v) => (hidden ? "•••" : usd(v));
  const opts = brokers.tradier?.options || [];
  return (
    <div className="fc-panel flex items-center gap-[1.2em] px-[0.9em] py-[0.25em] fc-num text-[1em] min-w-0" data-testid="tv-brokers">
      {NAMES.filter(([k]) => brokers[k]).map(([k, label]) => (
        <span key={k} className="flex items-baseline gap-[0.4em] shrink-0" data-testid={`tv-broker-${k}`}>
          <span className="fc-label">{label}</span>
          {brokers[k].error ? <span className="text-[#FF3D68]">offline</span> : <b className="text-cyan-50">{show(brokers[k].equity ?? brokers[k].cash)}</b>}
          {k === "tradier" && !brokers[k].error && <span className="text-cyan-200/60">cash {show(brokers[k].cash)} · {opts.length} option{opts.length === 1 ? "" : "s"}</span>}
        </span>
      ))}
      {opts.length > 0 && (
        <span className="truncate text-amber-100/80" data-testid="tv-tradier-options">
          {opts.slice(0, 4).map((o) => `${o.symbol} ×${o.qty}${o.mark != null ? ` @ ${o.mark}` : ""}`).join(" · ")}
        </span>
      )}
    </div>
  );
};
